import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Duration } from "luxon";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getTimeSpentOnAppDaily } from "_controllers/officer";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";

const TimeSpent = () => {
  const { SAP_ID } = useParams();

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [onDate, setOnDate] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [csvData, setCsvData] = useState([]);

  const fileName = `${SAP_ID}-time-spent`;

  useEffect(async () => {
    const startDate = moment().startOf("month").format("YYYY-MM-DD");

    const endDate = moment().endOf("month").format("YYYY-MM-DD");

    const plan = await getTimeSpentOnAppDaily({
      SAP_ID,
      onDate,
      startDate,
      endDate,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }, [message]);

  const { selectStartDate, selectEndDate } = Values

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const plan = await getTimeSpentOnAppDaily({
      SAP_ID,
      startDate: selectStartDate,
      endDate: selectEndDate,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(csvData.map(x => ({
      'SAP ID': x._id.SAP_ID,
      'Date': x._id.date,
      'Time Spent(mins)': (x.total_count * 0.0166667).toFixed(0)
    })), fileName)
  }

  return (
    <>
      <Box>
        <form onSubmit={handleSubmit}>
          <Grid container xs={12} sx={{ m: 1 }}>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>Start Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectStartDate}
                  name="selectStartDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>End Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectEndDate}
                  name="selectEndDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
              <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
            </Grid>
          </Grid>
        </form>
      </Box>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>SAP_ID</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Date</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Time Spent (min)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length > 0
                  ? data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">
                        {d?._id?.SAP_ID}
                      </TableCell>
                      <TableCell align="center">{d?.date}</TableCell>
                      <TableCell align="center">
                        {Duration.fromMillis(d?.total_count * 1000).as('minutes').toFixed(0)} min
                      </TableCell>
                    </TableRow>
                  ))
                  : <Box sx={{ textAlign: 'left', pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>Time spent unavailable for today.</Typography>
                  </Box>}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default TimeSpent;
